import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Default = ({ post }: IProps) => {
	return (
		<a href={post.permalink} className="card simple-blog-card">
			{!!post.featured_image && (
				<figure
					className="simple-blog-card__figure"
					dangerouslySetInnerHTML={{ __html: post.featured_image }}
				/>
			)}
			<div className="simple-blog-card__content">
				<h3
					className="simple-blog-card__title t4"
					dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
				/>
			</div>
		</a>
	);
};

Default.displayName = 'Default';

export default Default;
